import { Icon } from "~components";
import { Css } from "~generated/css";
import { useTestIds } from "~utils";

type MobileAuthHeaderProps = {
  title: string;
  onBack: () => void;
};

export function MobileAuthHeader(props: MobileAuthHeaderProps) {
  const { title, onBack } = props;
  const tid = useTestIds(props, "mobileAuthHeader");
  return (
    <header css={Css.df.aic.w100.h8.$} {...tid}>
      {/* Back button, cheating and absolute position to easily center title */}
      <div css={Css.absolute.left0.p2.bcGray800.br4.$} onClick={onBack} {...tid.backButton}>
        <Icon name="arrow-back" />
      </div>
      <div css={Css.mxa.t24.gray800.$} {...tid.title}>
        {title}
      </div>
    </header>
  );
}
